<script>
import FormModel from "@/views/Boarding/Components/FormModel.vue";

export default {
    name: "OnBoardingForm",
    components: {FormModel},
    props: {
        addAction: Boolean,
        deleteAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
    },
}
</script>

<template>
        <FormModel
                :add-action="addAction"
                :update-action="updateAction"
                :delete-action="deleteAction"
                :view-action="viewAction"
                category="ON"
        />
</template>